// extracted by mini-css-extract-plugin
export var container = "_ld-0";
export var segment = "_ld-2";
export var segmentActive = "_ld-3";
export var track = "_ld-1";